export default __webpack_public_path__ + "static/media/jardiniere.6209f405.jpg";